import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import(`./views/Home.vue`);
const About = () => import(`./views/About.vue`);
const Contact = () => import(`./views/Contact.vue`);
const Terms = () => import(`./views/Terms.vue`);
const Privacy = () => import(`./views/Privacy.vue`);
const Section = () => import(`./views/Section.vue`);
const BookDetails = () => import(`./views/BookDetails.vue`);
const Authors = () => import(`./views/Authors.vue`);
const Author = () => import(`./views/Author.vue`);
const Search = () => import(`./views/Search.vue`);
const CategoryBooks = () => import(`./views/CategoryBooks.vue`);
const Gallery = () => import(`./views/Gallery.vue`);
const Events = () => import(`./views/Events.vue`);
const Press = () => import(`./views/Press.vue`);
const EventDetails = () => import(`./views/EventDetails.vue`);
const PressDetails = () => import(`./views/PressDetails.vue`);
const Downloads = () => import(`./views/Downloads.vue`);
const Success = () => import(`./views/Success.vue`);
const Failed = () => import(`./views/Failed.vue`);
const Cancel = () => import(`./views/Cancel.vue`);

const AllCategory = () => import(`./views/AllCategory.vue`);
const Publishers = () => import(`./views/Publishers.vue`);
const Publisher = () => import(`./views/Publisher.vue`);
const CMSPage = () => import(`./views/CMSPage.vue`);
const Offer = () => import(`./views/Offer.vue`);


//ecommerce
const Login = () => import(`./views/Login.vue`);
const Signup = () => import(`./views/Signup.vue`);
const ForgotPassword = () => import(`./views/ForgotPassword.vue`);
const ForgotPasswordOtp = () => import(`./views/ForgotPasswordOtp.vue`);
const ResetPassword = () => import(`./views/ResetPassword.vue`);
const Cart = () => import(`./views/Cart.vue`);
const Checkout = () => import(`./views/Checkout.vue`);
const Dashboard = () => import(`./views/Dashboard.vue`);
const Profile = () => import(`./views/Profile.vue`);
const Orderlist = () => import(`./views/Orderlist.vue`);
const ChangePassword = () => import(`./views/ChangePassword.vue`);
const Wishlist = () => import(`./views/Wishlist.vue`);
const Addresses = () => import(`./views/Addresses.vue`);
const OrderDetails = () => import(`./views/OrderDetails.vue`);

const Blogs = () => import(`./views/Blogs.vue`);
const BlogDetails = () => import(`./views/BlogDetails.vue`);

Vue.use(Router);

let router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: `/`,
            name: `home`,
            component: Home,
        },
        {
            path: `/blogs`,
            name: `blogs`,
            component: Blogs,
        }, 
        {
            path: `/blogs/:id`,
            component: BlogDetails,
        },
        {
            path: `/success`,
            name: `success`,
            component: Success,
        },{
            path: `/failed`,
            name: `failed`,
            component: Failed,
        },{
            path: `/cancel`,
            name: `cancel`,
            component: Cancel,
        },{
            path: `/login`,
            name: `login`,
            component: Login,
        }, {
            path: `/signup`,
            name: `signup`,
            component: Signup,
        }, {
            path: `/forgot-password`,
            name: `forgotpassword`,
            component: ForgotPassword,
        }, {
            path: `/forgot-password-otp`,
            name: `ForgotPasswordOtp`,
            component: ForgotPasswordOtp,
        }, {
            path: `/reset-password`,
            name: `ResetPassword`,
            component: ResetPassword,
        }, {
            path: `/customer/dashboard`,
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                layout: 'Customer',
                requiresAuth: true
            },
            children: [
                {
                    path: "profile",
                    name: "profile",
                    component: Profile,
                },
                {
                    path: "order",
                    name: "order",
                    component: Orderlist,
                },
                {
                    path: "order/:id",
                    name: "OrderDetails",
                    component: OrderDetails,
                },
                {
                    path: "addresses",
                    name: "Addresses",
                    component: Addresses,
                },                
                {
                    path: "wishlist",
                    name: "Wishlist",
                    component: Wishlist,
                },
                {
                    path : 'change-password',
                    name : 'Change-Password',
                    component:ChangePassword
                }
            ]
        },{
            path: `/cart`,
            name: 'Cart',
            component: Cart,
        }, {
            path: `/checkout`,
            name: `Checkout`,
            component: Checkout,
        }, {
            path: `/publishers`,
            name: `publishers`,
            component: Publishers,
        },{
            path: `/publisher/:id`,
            name: `publisher`,
            component: Publisher,
        },{
            path: `/authors/:type`,
            name: `authors`,
            component: Authors,
        }, {
            path: `/author/:id`,
            name: `author`,
            component: Author,
        }, {
            path: `/about`,
            name: `about`,
            component: About,
        }, {
            path: `/contact`,
            name: `contact`,
            component: Contact,
        }, {
            path: `/terms-of-service`,
            name: `terms`,
            component: Terms,
        }, {
            path: `/privacy-policy`,
            name: `privacy`,
            component: Privacy,
        }, {
            path: `/book/:id`,
            name: `book`,
            component: BookDetails,
            props: true
        },{
            path: `/book/:id/:slug`,
            name: `book`,
            component: BookDetails,
            props: true
        }, {
            path: `/section/:id/:slug`,
            name: `section`,
            component: Section,
            props: true
        }, {
            path: `/book-search`,
            component: Search
        }, {
            path: `/category`,
            component: AllCategory
        },{
            path: `/category/:categoryId/:order`,
            component: CategoryBooks
        }, {
            path: `/gallery`,
            component: Gallery
        }, {
            path: `/events`,
            component: Events
        }, {
            path: `/event/:id`,
            component: EventDetails,
            props: true
        }, {
            path: `/press`,
            component: Press
        }, {
            path: `/press/:id`,
            component: PressDetails,
            props: true
        }, 
        {
            path: `/downloads`,
            component: Downloads,
        },
        {
            path: `/page/:id`,
            name: `CMSPage`,
            component: CMSPage,
        },
        {
            path: `/offer/:offerType`,
            name: `Offer`,
            component: Offer,
        }
    ],
    mode: `history`
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('token')) {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

router.afterEach(() => {
  if (window.fbq) fbq('track', 'PageView');
});

export default router